import React from 'react';
import { ReactComponent as EmergencyNoticeSvg } from './emergencyNotice.svg';

const EmergencyNotice = function () {
  return <EmergencyNoticeSvg />;
};

export default EmergencyNotice;
